import { Box, Palette, Typography } from "@mui/material";

export const ErrorBlock = ({
  content,
  palette,
}: {
  content?: string;
  palette: Palette;
}) => (
  <Box
    sx={{
      backgroundColor:
        palette.mode === "dark" ? palette.grey[900] : palette.grey[50],
      border: `1px solid ${palette.error.main}`,
      borderRadius: 1,
      p: 1.5,
      mb: 1,
    }}
  >
    <Typography variant="body2" sx={{ color: palette.error.main }}>
      {content}
    </Typography>
  </Box>
);
